/**
 * When the daily training reminder ("Trainingserinnerungen") is sent to a
 * patient. The patient picks one of three fixed slots in their notification
 * settings — the hours are part of the product contract (they are named in the
 * dropdown labels), which is why they live here next to the enum rather than in
 * a deployment config.
 *
 * {@link MORNING} is the default: a reminder that arrives before the day fills
 * up leaves the whole day to act on it. It replaces the fixed 18:00 send the
 * single, non-choosable reminder had before TM-9530.
 */
export var TrainingReminderTime;
(function (TrainingReminderTime) {
    TrainingReminderTime["MORNING"] = "MORNING";
    TrainingReminderTime["NOON"] = "NOON";
    TrainingReminderTime["EVENING"] = "EVENING";
})(TrainingReminderTime || (TrainingReminderTime = {}));
/** The send hour of each slot, in `Europe/Berlin`. */
export const TRAINING_REMINDER_HOUR = {
    [TrainingReminderTime.MORNING]: 6,
    [TrainingReminderTime.NOON]: 12,
    [TrainingReminderTime.EVENING]: 18,
};
/** German labels for the settings dropdown. */
export const TRAINING_REMINDER_LABEL = {
    [TrainingReminderTime.MORNING]: 'morgens (6 Uhr)',
    [TrainingReminderTime.NOON]: 'mittags (12 Uhr)',
    [TrainingReminderTime.EVENING]: 'abends (18 Uhr)',
};
export const TRAINING_REMINDER_TIMES = [
    TrainingReminderTime.MORNING,
    TrainingReminderTime.NOON,
    TrainingReminderTime.EVENING,
];
//# sourceMappingURL=training-reminder-time.enum.js.map